const complementaryProducts = document.querySelector('.complementary-products-advanced');

/* NUMBER TO EURO */

function numberToEuro(number){
    const euroValue = (parseInt(number) / 100).toFixed(2).replace(".", ",") + "€";
    return euroValue;
}

/* MAIN BUTTON */

function updateMainButtonPrice() {

    const productQuantity = document.querySelector('.product .quantity-selector__input')

    if (productQuantity) {

        // GET PRODUCT PRODUCT PRICE x QUANTITY

        const productQuantityValue = productQuantity.value;

        const productPrice = document.querySelector('#product-price').value;
        const productFinalPriceWithQuantity = productPrice*productQuantityValue;
        let complementaryProductsPrice = 0;

        if (complementaryProducts) {

            // GET COMPLEMENTARY PRODUCTS PRICE
            complementaryProductsPrice = document.querySelector('#complementary-products-price').value;
            const productComplementaryProducts = complementaryProducts.querySelectorAll('.products .item');

            productComplementaryProducts.forEach(product => {
                if(product.getAttribute('selected') != null) {
                    const productPrice = product.querySelector('.final-price');
                    if(productPrice.dataset.price){
                        complementaryProductsPrice = parseInt(complementaryProductsPrice) + parseInt(productPrice.dataset.price);
                    }
                }
            });

        }

        // SET NEW FINAL PRICE

        const productMainSubmitButton = document.querySelector('.product .buy-buttons button[type="submit"]');
        const newProductFinalPrice = parseInt(productFinalPriceWithQuantity) + parseInt(complementaryProductsPrice);

        if (productMainSubmitButton) {
            const buttonFinalPrice = productMainSubmitButton.querySelector('.final-price');
            buttonFinalPrice.innerHTML = numberToEuro(newProductFinalPrice);
        }

    }

  
}
updateMainButtonPrice()

/* PRODUCT QUANTITY */

const quantitySelector = document.querySelector('.product .quantity-selector'); 

if (quantitySelector) {

    const quantitySelectorButtons = quantitySelector.querySelectorAll('.quantity-selector__button');

    quantitySelectorButtons.forEach(button => {
        button.addEventListener('click', () => {
            updateMainButtonPrice();
        })
    })

}

/* PRODUCT OPTIONS */

function setProductOptions(){

    updateMainButtonPrice();

    const productOptions = document.querySelectorAll('.variant-picker__option-values .block-swatch');

    if (productOptions) {
        productOptions.forEach(option => {
            option.addEventListener('click', () => {
                updateMainButtonPrice();
            })
        })
    }

}

setInterval(setProductOptions, 500);